import { NavItem } from 'react-bootstrap';
import { NavWrapper } from '@nkr/views/xm-tracking/styles';
import { ISerologyTrackingCounts, SerologyTrackingListType } from '@nkr/models/index';

interface IProps {
    listType: SerologyTrackingListType,
    counts: ISerologyTrackingCounts,
    onTabChange: (tab: any) => void
}

const Tabs = (props: IProps) => {
    let psCounts = props.counts != null ? props.counts.pendShippingCount : 0;
    let stdcCounts = props.counts != null ? props.counts.shippedToDonorCenterCount : 0;
    let sbtvCounts = props.counts != null ? props.counts.shippedBackToVendorCount : 0;
    let completedCounts = props.counts != null ? props.counts.completedCount : 0;
    let cancelledCounts = props.counts != null ? props.counts.cancelledCount : 0

    return (
        <div style={{ marginBottom: 5 }}>
            <NavWrapper bsStyle='tabs' bsSize='sm' activeKey={props.listType} onSelect={(tab: any) => props.onTabChange(tab)}>
                <NavItem eventKey={SerologyTrackingListType.PendShipping}>Pending Shipping ({psCounts})</NavItem>
                <NavItem eventKey={SerologyTrackingListType.ShippedToDonorCenter}>Shipped to Donor Center ({stdcCounts})</NavItem>
                <NavItem eventKey={SerologyTrackingListType.ShippedBackToVendor}>Shipped Back to Vendor ({sbtvCounts})</NavItem>
                <NavItem eventKey={SerologyTrackingListType.Completed}>Completed ({completedCounts})</NavItem>
                <NavItem eventKey={SerologyTrackingListType.Cancelled}>Cancelled ({cancelledCounts})</NavItem>
            </NavWrapper>
        </div>
    );
}

export default Tabs;